<template>
  <div>
    <b-form>
      <b-row>
        <b-col
          cols="12"
        >
          <b-button
            variant="primary"
            type="submit"
            class="addAwaitBtn"
            @click.prevent="validationAwaitForm"
          >
            {{ $t('DEBTIA_SUBMIT') }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import {
  BButton,
  BForm,
  BRow,
  BCol,
// BInputGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import { required, integer } from '@validations'

export default {
  components: {
    // BCardCode,
    BForm,
    BRow,
    BCol,
    BButton,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      integer,
    }
  },
  created() {
  },
  methods: {
    validationAwaitForm() {
      const processID = this.$route.params.id
      const dataObj = {
        process_id: Number(processID),
        module_id: 17,
        module_order: 1,
      }
      if (this.conditionObject.moduleID > 0) {
        dataObj.depends_on = this.conditionObject.moduleID
        dataObj.condition = this.conditionObject.type
      }
      const url = '/process/module/add'
      axios.post(url, dataObj).then(response => {
        if (response.status === 200) {
          const returnObj = {
            parentID: this.conditionObject.parentID,
            depend: dataObj.depends_on,
          }
          returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
          this.$emit('closeBailiffModal', returnObj)
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.addAwaitBtn {
    width: 100%;
}
</style>
